<div class="flex justify-content-between p-4">
  <div class="text-xl sm:text-2xl font-medium text-secondary-dark w-full">
    {{ currentPageTitle }}
  </div>
  <div class="sm:w-10">
    <div class="flex justify-content-end">
      <div class="cursor-pointer sm:fixed">
        <img
          src="assets/images/menu.svg"
          alt="Menu"
          (click)="overlayRef.toggle($event)"
        >
        <p-overlayPanel #overlayRef>
          <div class="p-3 surface-overlay">
              <div
              class="cursor-pointer mb-2 hover:bg-gray-100 p-2 rounded"
              (click)="navigateToHome(); overlayRef.hide()"
            >
              Home
            </div>
            <div
              class="cursor-pointer mb-2 hover:bg-gray-100 p-2 rounded"
              (click)="navigateToAbout(); overlayRef.hide()"
            >
              About
            </div>
            <div
              class="cursor-pointer hover:bg-gray-100 p-2 rounded"
              (click)="openShareDialog(); overlayRef.hide()"
            >
              Share  Link
            </div>
              <div
              class="cursor-pointer hover:bg-gray-100 p-2 rounded"
              (click)="navigateToInstallApp(); overlayRef.hide()"
            >
               Install App
            </div>
          </div>
        </p-overlayPanel>
      </div>
      <!-- <div class="cursor-pointer fixed" *ngIf="!isPaymentPage()" (click)="openMenu($event)">
        <img src="assets/images/menu.svg" alt="Menu">
      </div> -->
    </div>
  </div>
</div>

<app-install-overlay #appInstall></app-install-overlay>
<app-menu></app-menu>
